import * as types from '../actions/actionTypes'

export default function updateReducer(state = [], action) {
    switch (action.type) {
        case types.UPDATE_PAGE:
            return action.value;
        case types.UPDATE_RESET:
            return "";
        default:
            return state;
    }
}